import instance from 'utils/axios/instance.axios';
import { PROJECTS } from './_constant';

export const getAll = () => instance.get(PROJECTS.GET_ALL);
export const getFilters = (param) => instance.get(PROJECTS.GET_ALL, { params: param });

const ON_GOING_STATUS = ['doing', 'liquidation'];
export const getOngoingProjects = (filters) => getFilters({ ...filters, status: ON_GOING_STATUS });

const COMPLETED_STATUS = ['completed'];
export const getCompletedProjects = (filters) =>
  getFilters({ ...filters, status: COMPLETED_STATUS });

export const getProjectById = (id) => instance.get(PROJECTS.GET_PROJECT_BY_ID(id));
export const submitProfile = (id) => instance.post(PROJECTS.POST_SUBMIT_BY_ID(id));
export const getProjectByProjectProposalId = (projectProposalId) =>
  instance.get(PROJECTS.GET_PROJECT_BY_PROJECT_PROPOSAL_ID(projectProposalId));

export const getAttachment = (id) => instance.get(PROJECTS.GET_ATTACHMENT(id));

export const getAdjustmentsById = (id) => instance.get(PROJECTS.GET_ADJUSTMENTS_BY_ID(id));

export const downloadFile = (body) =>
  instance.post(PROJECTS.POST_DOWNLOAD_PDF(body.projectId), body, { responseType: 'blob' });
export const getProjectCode = (projectId) => instance.get(PROJECTS.GET_PROJECT_CODE(projectId));

export const getDataForRegisterResult = (projectId, councilType) =>
  instance.get(PROJECTS.GET_DATA_FOR_REGISTER_RESULT(projectId), {
    params: { councilType },
  });

export const downloadCertificationPDF = (projectId) =>
  instance.get(PROJECTS.DOWNLOAD_CERTIFICATION_PDF(projectId), { responseType: 'blob' });

export const downloadCertificationDOCX = (projectId) =>
  instance.get(PROJECTS.DOWNLOAD_CERTIFICATION_DOCX(projectId), { responseType: 'blob' });
